import { render, staticRenderFns } from "./ActiveAccountsTable.vue?vue&type=template&id=36f25fe7"
import script from "./ActiveAccountsTable.vue?vue&type=script&lang=js"
export * from "./ActiveAccountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports